import * as React from 'react';
import { Slug } from '@fnv-core/utils';
import { addConditionalClass } from '../../../../helpers';

export interface IPageTitleProps {
  /**
   * True for h1, false for h2
   */
  main: boolean;
  /**
   * The title text to display
   */
  title: string;
  /**
   * An optional subtitle render function
   */
  subtitleRender?: () => JSX.Element | string;
  /**
   * An optional modifier class for the subtitle
   */
  subtitleModifierClass?: string;
  /**
   * An optional intro
   */
   intro?: string;

  children?: any;
}

/**
 * Component for displaying a Page Title with an optional subtitle in `children`
 * @param {IPageTitleProps} props
 */
export const PageTitle = (props: IPageTitleProps) => {
  const headingClassName = `mijn-fnv-${Slug.fromString(props.title)}__title`;
  const showDivider = props.main && !props.intro;

  const subtitleClass = addConditionalClass('content__subtitle', `content__subtitle-${props.subtitleModifierClass}`, !!props.subtitleModifierClass);

  return (
    <>
      {props.main 
        ? <h1 className={headingClassName}>{props.title}</h1>
        : <h2 className={headingClassName}>{props.title}</h2>
      }
      {props.subtitleRender && <h2 className={subtitleClass}>{props.subtitleRender()}</h2>}
      {props.intro && <p className="content__intro mb-4">{props.intro}</p>}
      {showDivider && <div className="content__hr"></div>}
    </>
  );
};
